const CHECKOUT_INTENT_KEY = 'leechall_checkout_intent'
const CHECKOUT_INTENT_TTL = 24 * 60 * 60 * 1000

export const isSafeInternalPath = path => (
  typeof path === 'string'
  && path.startsWith('/')
  && !path.startsWith('//')
)

export const isCheckoutPath = path => (
  isSafeInternalPath(path)
  && /^\/premium\/[^/?#]+\/[^/?#]+(?:[?#].*)?$/.test(path)
)

const removeStoredCheckoutIntent = () => {
  try {
    localStorage.removeItem(CHECKOUT_INTENT_KEY)
    return true
  } catch {
    return false
  }
}

export const saveCheckoutIntent = path => {
  if (!isCheckoutPath(path)) return false

  try {
    localStorage.setItem(
      CHECKOUT_INTENT_KEY,
      JSON.stringify({
        path,
        createdAt: Date.now(),
      }),
    )
    return true
  } catch {
    return false
  }
}

export const getCheckoutIntent = () => {
  try {
    const intent = JSON.parse(
      localStorage.getItem(CHECKOUT_INTENT_KEY) || 'null',
    )

    if (
      !intent
      || !isCheckoutPath(intent.path)
      || Date.now() - intent.createdAt > CHECKOUT_INTENT_TTL
    ) {
      removeStoredCheckoutIntent()
      return null
    }

    return intent.path
  } catch {
    removeStoredCheckoutIntent()
    return null
  }
}

export const clearCheckoutIntent = () => {
  removeStoredCheckoutIntent()
}
